import { gql } from "@apollo/client";

export const RETRY_RUN = gql`
  mutation RetryMostRecentRunNext($stackId: ID!, $runId: ID!) {
    runRetry(stack: $stackId, run: $runId) {
      id
    }
  }
`;
